"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CameraKnockItem = require("./CameraKnockItem");
Object.keys(_CameraKnockItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CameraKnockItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CameraKnockItem[key];
    }
  });
});